import styled from 'styled-components';
import { allStyles } from '../styleHelper2';
import styleFilter from '../styleFilter';

const Text = styled(styleFilter(styled.span``))`
  line-height: 1.4em;
  font-family: Circular;
  ${allStyles()}
`;

export default Text;
